<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.table">
  <div class="banner center" style="max-width:800px;" *ngIf="wrappers">
    <div class="row row_header">
      <div class="col-7">
        {{localService.languageContent.table.action}}
      </div>
      <div class="col-5">
        {{localService.languageContent.table.title}}
        <div class="icon_action_header" style="top:-5px;">
          <button class="button_icon button_icon_color" style="margin-right: 5px;"
            (click)="onLoad()">replay_circle_filled</button>
          <button class="button_icon button_icon_color" (click)="openCreateEditPopup('')"
            title="{{localService.languageContent.common.add}}">note_add</button>
        </div>
      </div>
    </div>
    <div class="row styled_row" *ngFor="let item of wrappers">
      <div class="col-7">
        <i class="material-icons button icon_adjust"
          title="{{item.v5 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
          (click)="onActiveInactiveStatus(item.key)"
          [ngStyle]="{'color': item.v5 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v5 == '1' ? "toggle_on" :
          "toggle_off"}}</i>
        <a class="button" [routerLink]="['/locations' + localService.basicParamsString,item.key]"><i
            class="material-icons button icon_adjust">account_tree</i></a>
        <a class="button" [routerLink]="['/fields-config' + localService.basicParamsString,item.key]"><i
            class="material-icons button icon_adjust">text_fields</i></a>
        <i class="material-icons button icon_adjust" (click)="onAction(2,item.key)">file_download</i>
        <i class="material-icons icon_adjust" (click)="onAction(1,item.key)">file_upload</i>
        <i class="material-icons icon_adjust" (click)="onAction(3,item.key)">monetization_on</i>
        <button class="button_icon button_icon_color" style="top: 8px;"
          (click)="onAction(5,item.v1)">g_translate</button>
        <button class="button_icon button_icon_color" style="top: 8px;" (click)="onAction(4,item.v1)">search</button>
        <button type="button" class="button_icon button_icon_color" style="top: 5px !important;"  (click)="onGenerateRent(item.key)"
              title="{{localService.languageContent.common.generate_rent}}">play_arrow</button>
      </div>
      <div class="col-5">
        <span class="button en" (click)="openCreateEditPopup(item.key)">{{item.v1}} &nbsp;</span>
        <span>{{item.v4}}</span>
      </div>
    </div>
  </div>
  <div style="display:none">
    <app-file-upload [Id]="elementIds.file" [fileUploadFor]="FileUploadFor.Locations" [forId]="selectedCountry" [forId2]="selectedLanguage"></app-file-upload>
  </div>
</div>

<div>
  <app-country-configuration [(isOpenPopup)]="isCountryConfigOpen" [id]="selectedCountryId"></app-country-configuration>
</div>